
import React, { useState } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
  TableRow, Table,
  TableHead,
  TableBody,
  TableCell,
   TableContainer,
                Paper,
  Checkbox, FormControlLabel,
} from "@material-ui/core";

import { Card, Box } from "@material-ui/core";
import CalenderAssignmentService from "./Locality/Service/calenderAssignmentService";
import AddClassService from "./Locality/Service/addClassService";
import StudentService from "./Locality/Service/studentService";
import IconMasterService from "./Locality/Service/iconMasterService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));
export default function CalenderAssignment() {
  const tableHeaders = ['Student', 'Event Name ', 'Class', 'Special notes', 'Date', 'Edit', 'Delete'];
  const [images, setImages] = useState('');
  const [imageslist, setImagesList] = useState('');
  const [message, setMessage] = useState("");
  const classes = useStyles();
  const [studentList, setStudentList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [calenderAssignmentList, setCalenderAssignmentList] = useState([]);
  const [activeIcons, setActiveIcons] = useState([]);
  const [dueDate, setFormDueDate] = useState("");
  const [age, setAge] = React.useState('');
  var [error, setError] = useState(null);
  var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(100);
  const current = new Date();
  var [classId, setClassId] = useState("");
  const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
  var [dateValue, setDateValue] = useState(date);
  const [eventId, setEventId] = useState('');
  const [year, month, day] = date.split("-");
  const [calenderAssignment, setCalenderAssignment] = useState({
    eventName: '',
    imageURL: [],
    observation: '',
    video: '',
    studentId: [],
    date: '',
    isEventForAllStudent: false,
    iconId: '',
  });

 
  const validationSchema = Yup.object().shape({
    eventName: Yup.string().required('event Name is required'),
    studentId: Yup.array(),
    video: Yup.string(),
    date: Yup.string(),
    observation: Yup.string(),
    classId: Yup.string(),
    imageURL: Yup.array(),
    isEventForAllStudent: Yup.boolean(),
    iconId: Yup.string(),
  });
 
  const verifyeetnt = () => {
    console.log(formik)
  }
  const handleOpen = (status) => {


    if (status) {
      setCalenderAssignment({
        eventName: '',
    imageURL: [],
    observation: '',
    video: '',
    studentId: [],
    date: '',
    isEventForAllStudent: false,
    iconId: '',
      })
    }

    setOpen(true);
  };
  const handleChangePage = (event, newpage) => {
    setpg(newpage);
  }
  const handleChangeRowsPerPage = (event) => {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }
  useEffect(() => {
    getCalenderAssignmentList();
    getAddClassList();
    getActiveIcons();
    return () => {
      setCalenderAssignmentList([]);
      setStudentList([]);
    }
  }, []);

  const getActiveIcons = () => {
    const body = { status: 'active' };
    IconMasterService.findIconMasterList(body)
      .then((res) => {
        setActiveIcons(res || []);
      })
      .catch((err) => {
        console.error("Error fetching active icons:", err);
      });
  };
  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormDueDate(value);
  };
  const handleFileChange = (e) => {
    setImages(e.target.files); // Store all selected files in state
  };
  const handleUpload = async (e) => {
    e.preventDefault();

    if (images.length === 0) {
      setMessage("Please select images first.");
      return;
    }

    // Create FormData and append each file
    const formData = new FormData();
    if (images.length > 0) {
      const image = images[0];
      formData.append(`image`, image);

      formData.append(`imageName`, image.name);
      // images.forEach((image, index) => {
      //   formData.append(`images`, image); // Append each file to the form
      // });

      try {
        // Send the images to the API
        CalenderAssignmentService.uploadImage(formData).then((res) => {

          alert(`Images uploaded successfully`);
          setImagesList((prev) => [...prev, res.url]);


        }).catch((err) => {
          alert(err.message);
        });

      } catch (error) {
        console.error("Error uploading images:", error);
        setMessage("An error occurred while uploading the images.");
      }
    }

  };

  // Function to format date to D/M/Y format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        // If dateString is already in YYYY-MM-DD format, parse it manually
        const parts = dateString.split("-");
        if (parts.length === 3) {
          const day = parts[2];
          const month = parts[1];
          const year = parts[0];
          return `${day}/${month}/${year}`;
        }
        return dateString;
      }
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const getCalenderAssignmentList = () => {

    CalenderAssignmentService.getAllCalenderAssignment()
      .then((res) => {
        // Keep dates in original format, format them when displaying in table
        setCalenderAssignmentList(res);
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  const handleOpen1 = () => {
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen(false);
    setImages([]);
    setImagesList([]);
    // Reset form when closing
    const resetData = {
      eventName: '',
      imageURL: [],
      observation: '',
      video: '',
      studentId: [],
      date: '',
      isEventForAllStudent: false,
      iconId: '',
    };
    setCalenderAssignment(resetData);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const getAddClassList = (event) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
      if (userDetails.role === "TEACHER") {
        res = res.filter(res => res._id === userDetails.classId);
      }
      setAddClassList(res);
      if (userDetails.classId) {
        setClassId(userDetails.classId);
        getStudentList({ target: { value: userDetails.classId } });
      } else {
        setClassId(""); // No default selection
      }
    }).catch((err) => {
      // setError(err.message);
    });
  }
 
  const editCalenderAssignment = (calenderassignment, status) => {
    const obj = JSON.parse(JSON.stringify(calenderassignment, status));
    obj.classId = calenderassignment.classId ? calenderassignment.classId._id : '';
    obj.studentId = Array.isArray(calenderassignment.studentId)
    ? calenderassignment.studentId.map(student => student._id)
    : calenderassignment.studentId
    
    // Handle iconId - it can be an object (populated) or a string ID
    if (calenderassignment.iconId) {
      if (typeof calenderassignment.iconId === 'object' && calenderassignment.iconId._id) {
        obj.iconId = calenderassignment.iconId._id;
      } else if (typeof calenderassignment.iconId === 'string') {
        obj.iconId = calenderassignment.iconId;
      } else {
        obj.iconId = '';
      }
    } else {
      obj.iconId = '';
    }

    // Set existing images if any
    if (calenderassignment.imageURL && Array.isArray(calenderassignment.imageURL) && calenderassignment.imageURL.length > 0) {
      setImagesList(calenderassignment.imageURL);
    } else {
      setImagesList([]);
    }

    getStudentList({ target: { value: obj.classId } }, obj);

    getAddClassList({ target: { value: obj.superActivityId } }, obj)
    //getStudentActivityList(useractivitys.classId);

    if (status) {
      delete obj._id;
    }
    setCalenderAssignment(obj);
    handleOpen()
  }
  const removeImage = (index, imageURL) => {
    CalenderAssignmentService.deleteAzureImage({"imageURL":imageURL}).then((res) => {
            const updatedList = [...imageslist];
            updatedList.splice(index, 1);
            setImagesList(updatedList);
          }).catch((err) => {
          });
};
  const deleteCalenderAssignment = (calenderassignment) => {
    if (calenderassignment) {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this Event?"
      );
      
      if (!confirmDelete) {
        return;
      }

      CalenderAssignmentService.deleteCalenderAssignment(calenderassignment).then((res) => {
        getCalenderAssignmentList();
        // Dispatch custom event to notify Calendar.js to refresh
        window.dispatchEvent(new CustomEvent('calendarEventDeleted', { 
          detail: { eventId: calenderassignment._id } 
        }));
        alert("Event deleted successfully!");
      }).catch((err) => {
        alert(err.response?.data?.message || "Error deleting event");
      });
    }
  }


  const getStudentList = (event, obj) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    const getSpeList = { classId: event.target.value };
    StudentService.getAllStudentById(userDetails.schooleId,
      getSpeList
    ).then((res) => {
      const studentDetails = res.map(res => {
        return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
      })
      setStudentList(studentDetails);

    }).catch((err) => {
      // setError(err.message);
    });
  }

  const formik = useFormik({
    initialValues: calenderAssignment,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      debugger
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      values.schooleId = userDetails.schooleId;
      //values.date = dueDate;
      values.studentId = values.studentId ? values.studentId : null;
      values.iconId = values.iconId || null;
      if (calenderAssignment._id) {

        CalenderAssignmentService.upadeCalenderAssignment(values).then((res) => {

          handleClose();
          getCalenderAssignmentList();
          resetForm()
          setImagesList([])
          // Dispatch custom event to notify Calendar.js to refresh
          window.dispatchEvent(new CustomEvent('calendarEventUpdated', { 
            detail: { eventId: calenderAssignment._id } 
          }));
          alert(" Event Updated Successfully.");
        }).catch((err) => {
        });
      }
      else {
        values.imageURL = imageslist;


        CalenderAssignmentService.creteCalenderAssignment(values).then((res) => {
          getCalenderAssignmentList();
          resetForm();
          handleClose();
          // Dispatch custom event to notify Calendar.js to refresh
          window.dispatchEvent(new CustomEvent('calendarEventAdded', { 
            detail: { event: res } 
          }));
          alert(" Event Added Successfully.");
          setImagesList([])
        })
          .catch((err) => {
            alert(err.response.data.message)
          })
      }

    },
  });

  const test = () => {
    console.log(formik)
  };
  const handleCheck = (event, item) => {
    // event.sounds.SPL
    event.sounds[item] = !event.sounds[item];
    // obj['a'] = true;

    StudentService.upadeStudent(event).then((res) => {
      getStudentList();

    })
      .catch((err) => {
        alert(err.response.data.message)
      })

  };
  // const imageArtist = (eventdetails) => {
  //   getEventImageList(eventdetails.id);
  //   setEventId(eventdetails.id)

  // }
  const getCalenderAssignmentImageList = (eventId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    // CommonService.postRequest(IMAGES.GET+"/getlist", {artiesId:eventId}).then((res) => {
    //     setEventImageList(res);
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue, "eventId": userDetails.calenderAssignmentId
    }
    CalenderAssignmentService.creteImages(keys).then((res) => {
      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

    });
  }
  const onSubmit = data => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue
    }
    CalenderAssignmentService.creteCalenderAssignment(keys).then((res) => {

      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

      alert(err.response.data.message);
    });
  };
  return (

    <>

      <PageTitle title="Calender Of Events" button={<Button

        variant="contained" onClick={() => handleOpen(true)}
        size="medium"
        color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add  Event
      </Button>} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
            
            <Table stickyHeader className="mb-0">
              <TableHead >
                <TableRow>
                  {tableHeaders.map(key => (
                    <StyledTableCell key={key}>{key}</StyledTableCell>
                  ))}
                </TableRow>

              </TableHead>
              <TableBody>
                
                {calenderAssignmentList.slice(pg * rpg, pg * rpg + rpg).map((calenderassignment) => (
                  <TableRow key={calenderassignment._id}>
                    {/* <TableCell className="pl-3 fw-normal" >
                      
                      {calenderassignment.studentId ? calenderassignment.studentId.firstName : ""}&nbsp;
                      {calenderassignment.studentId ? calenderassignment.studentId.lastName : ""}
                    </TableCell> */}
                    {/* <TableCell className="pl-3 fw-normal" >
                      {calenderassignment.studentId ? calenderassignment.studentId.firstName : ""}&nbsp;
                      {calenderassignment.studentId ? calenderassignment.studentId.lastName : ""}
                    </TableCell> */}
                    <TableCell className="pl-3 fw-normal">
                      {calenderassignment.isEventForAllStudent ?"All":  calenderassignment.studentId?.map((student, index) => (
                          <span key={student._id || index}>
                            {student.firstName} {student.lastName}
                            {index < calenderassignment.studentId.length - 1 ? ", " : ""}
                          </span>
                        ))}
                    
                    </TableCell>
                    <TableCell className="pl-3 fw-normal" >{calenderassignment.eventName}</TableCell>
                    {/* <TableCell className="pl-3 fw-normal" >{calenderassignment.imageURL}</TableCell>
                    <TableCell className="pl-3 fw-normal" >{calenderassignment.video}</TableCell> */}
                    <TableCell className="pl-3 fw-normal" >{calenderassignment.classId ? calenderassignment.classId.className : ''}</TableCell>

                    <TableCell className="pl-3 fw-normal" >{calenderassignment.observation}</TableCell>
                    <TableCell className="pl-3 fw-normal" >{formatDate(calenderassignment.date)}</TableCell>


                    <TableCell>
                      <EditIcon style={{ cursor: 'pointer' }} onClick={() => editCalenderAssignment(calenderassignment)} >
                      </EditIcon >
                    </TableCell>
                    <TableCell>
                      <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteCalenderAssignment(calenderassignment)} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer >
            <TablePagination
                            component="div"
                            rowsPerPageOptions={[ 1000, 10000, 1000000]}
                            count={calenderAssignmentList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
          </Widget>
        </Grid>
      </Grid>
      <Dialog 
        open={open} 
        onClose={handleClose}
        scroll="paper"
        PaperProps={{
          style: {
            maxHeight: '90vh',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle>Add Event</DialogTitle>


        <DialogContent 
          style={{ 
            width: 345,
            overflowY: 'auto',
            maxHeight: 'calc(90vh - 150px)',
            padding: '20px 24px'
          }}
        >
          <FormControl className={classes.formControl} fullWidth="true"
          >
            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="classId"
              label="selectClass"
               value={formik.values.classId}
              // value={classId}
              
              onChange={e => { formik.handleChange(e); getStudentList(e) }}
              // onChange={e => { setClassId(e.target.value); getStudentList(e);  }}
              // onChange={formik.handleChange}

              error={formik.touched.classId && Boolean(formik.errors.classId)}
              helperText={formik.touched.classId && formik.errors.classId}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>

              {addClassList.map(({ _id, className }) => (
                <MenuItem key={_id} value={_id}>{className}

                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <br></br>
          <br></br>
        
          <div>
             
             { formik.values.isEventForAllStudent}
             <Grid item xs={12} sm={12} md={12}>
               <FormControlLabel
                 control={
                   <Checkbox name="isEventForAllStudent" id="terms"
                     value={formik.values.isEventForAllStudent}
                     checked={formik.values.isEventForAllStudent}
                     onChange={formik.handleChange}
                     error={formik.touched.isEventForAllStudent && Boolean(formik.errors.isEventForAllStudent)}
                     helperText={formik.touched.isEventForAllStudent && formik.errors.isEventForAllStudent}
                   />
                 }
                 label="For All Class Students"
               />
             </Grid>


           </div>
          {/* <FormControl variant="standard" fullWidth>
              <InputLabel id="studentName">Student Name</InputLabel>
              <Select

                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Student Name"
                name="studentId"
                value={formik.values.studentId}

                onChange={formik.handleChange}
                error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                helperText={formik.touched.studentId && formik.errors.studentId}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {studentList.map(({ index, _id, studentName }) => (
                  <MenuItem key={index} value={_id}>{studentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

          {/* <FormControl variant="standard" fullWidth>
            <InputLabel id="studentName-label">Student Name</InputLabel>
            <Select

              labelId="studentName-label"
              id="studentName-select"
              label="Student Name"
              name="studentId"
              
              value={formik.values.studentId}

              onChange={formik.handleChange}
              error={formik.touched.studentId && Boolean(formik.errors.studentId)}
              helperText={formik.touched.studentId && formik.errors.studentId}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {studentList.map(({ index, _id, studentName }) => (
                <MenuItem key={index} value={_id}>{studentName}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
<FormControl variant="standard" fullWidth>
              <InputLabel id="studentName-label">Student Name</InputLabel>
              <Select
                labelId="studentName-label"
                id="studentName-select"
                label="Student Name"
                name="studentId"
                multiple
                value={formik.values.studentId} // make sure this is an array in Formik's initialValues
                onChange={formik.handleChange}
                // Customize how the selected values are displayed in the input
                renderValue={(selected) => {
                  // Find student names for the selected IDs
                  const selectedNames = studentList
                    .filter(({ _id }) => selected.includes(_id))
                    .map(({ studentName }) => studentName);
                  return selectedNames.join(", ");
                }}
              >
                {studentList.map(({ _id, studentName }) => (
                  <MenuItem key={_id} value={_id}>
                    {studentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          <TextField fullWidth
            margin="dense"
            id="eventName"
            name="eventName"
            label="Event"
            type="text"
            variant="standard"
            value={formik.values.eventName}
            onChange={formik.handleChange}
            error={formik.touched.eventName && Boolean(formik.errors.eventName)}
            helperText={formik.touched.eventName && formik.errors.eventName}
          />
          <br></br>
          <FormControl variant="standard" fullWidth>
            <InputLabel id="icon-select-label">Select Icon (Optional)</InputLabel>
            <Select
              labelId="icon-select-label"
              id="iconId"
              name="iconId"
              label="Select Icon (Optional)"
              value={formik.values.iconId || ''}
              onChange={formik.handleChange}
              renderValue={(selected) => {
                if (!selected) return 'None';
                const selectedIcon = activeIcons.find(icon => icon._id === selected);
                if (selectedIcon) {
                  return (
                    <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <img 
                        src={selectedIcon.imageUrl} 
                        alt={selectedIcon.iconName}
                        style={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px' }}
                      />
                      <span>{selectedIcon.iconName}</span>
                    </Box>
                  );
                }
                return 'None';
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {activeIcons.map((icon) => (
                <MenuItem key={icon._id} value={icon._id}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img 
                      src={icon.imageUrl} 
                      alt={icon.iconName}
                      style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '4px' }}
                    />
                    <span>{icon.iconName}</span>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField InputProps={{ style: { width: 290 } }}
            id="date"
            name="date"
            label="Event Date"
            type="date"

            value={formik.values.date}
            onChange={formik.handleChange}
            error={formik.touched.date && Boolean(formik.errors.date)}
            helperText={formik.touched.date && formik.errors.date}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <br></br>
          <TextField fullWidth
            margin="dense"
            id="video"
            name="video"
            label="Video Link"
            type="text"
            variant="standard"
            value={formik.values.video}
            onChange={formik.handleChange}
            error={formik.touched.video && Boolean(formik.errors.video)}
            helperText={formik.touched.video && formik.errors.video}
          />

          <TextField fullWidth
            margin="dense"
            id="observation"
            name="observation"
            label="Special instructions"
            type="text"
            variant="standard"
            value={formik.values.observation}
            onChange={formik.handleChange}
            error={formik.touched.observation && Boolean(formik.errors.observation)}
            helperText={formik.touched.observation && formik.errors.observation}
          />

<br></br>

          <input fullWidth
            type="file"
            accept="image/*"
            // Enable multiple file selection
            onChange={handleFileChange}
          />
          <br></br>
          <br></br>
          <Button style={{ backgroundColor: 'rgb(21 61 96)', color: 'white', border: 'none' }} onClick={handleUpload}>Upload</Button>

        {imageslist.length > 0 && (
                               <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: 10 }}>
                                   {imageslist.map((url, index) => (
                                       <div key={index} style={{ position: 'relative' }}>
                                           <img
                                               src={url}
                                               alt={`Preview ${index + 1}`}
                                               style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 4 }}
                                           />
                                           <Button
                                               size="small"
                                               style={{ position: 'absolute', top: -5, right: -5, minWidth: 20, padding: 0 }}
                                               onClick={() => removeImage(index)}
                                           >
                                               ❌
                                           </Button>
                                       </div>
                                   ))}
                               </div>
                           )}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            type="submit" onClick={formik.handleSubmit}
          // onClick={test}
          >Add</Button>
        </DialogActions>

      </Dialog>
    </>
  );
}

